import { Component, Input, Directive, TemplateRef, ContentChild, HostBinding } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Directive({
  selector: '[zuiServiceStackTileCategory]'
})
export class ServiceStackTileCategoryDirective {
  constructor(public templateRef: TemplateRef<any>) {
  }
}

@Directive({
  selector: '[zuiServiceStackTileName]'
})
export class ServiceStackTileNameDirective {
  constructor(public templateRef: TemplateRef<any>) {
  }
}

@Component({
  selector: 'zui-service-stack-tile, button[zui-service-stack-tile], div[zui-service-stack-tile]',
  templateUrl: './service-stack-tile.component.html',
  styleUrls: [ './service-stack-tile.component.scss' ],
  preserveWhitespaces: false
})
export class ServiceStackTileComponent {

  @Input()
  icon: string;

  @Input()
  techIcons: string[];

  @Input()
  set isActive(v: string | boolean) {
    this._isActive = coerceBooleanProperty(v);
  }
  get isActive(): boolean { return this._isActive; }

  @ContentChild(ServiceStackTileCategoryDirective)
  categoryTemplateRef: ServiceStackTileCategoryDirective;

  @ContentChild(ServiceStackTileNameDirective)
  nameTemplateRef: ServiceStackTileNameDirective;

  @HostBinding('class.is-active')
  get classIsActive() {
    return this.isActive;
  }

  private _isActive = false;

  trackBy(index: number) {
    return index;
  }
}
